<nav
  class="bg-white border-2 border-l-0 border-t-0 border-r-0 pt-2 pb-1 md:pt-1 px-1 mt-0 h-auto fixed w-full z-30 top-0"
  [ngClass]="{
    'border-proTeal-700': configurationService.currentBrand === 'formkiq',
    'border-gray-900': configurationService.currentBrand === '24hourcharts'
  }"
  >
  <div class="flex flex-wrap items-center">
    <div
      [routerLink]="['/']"
      *ngIf="configurationService.currentBrand === 'formkiq'"
      class="flex flex-shrink md:w-1/3 items-start justify-center md:justify-start text-white ml-2 focus:outline-none cursor-pointer"
      >
      <img src="../../../assets/svg/formkiq-stacks.svg" class="w-8 h-12 md:w-12 mr-3 md:mr-4 pt-1" />
      <div>
        <h1
          class="pt-1 md:pt-0 text-xl -mb-1 font-black font-brand-formkiq text-coreOrange-500"
          >
          FormKiQ Cloud
        </h1>
        <h4 class="text-base uppercase font-bold text-proTeal-600 tracking-loose">
          Console
        </h4>
      </div>
    </div>
    <div
      [routerLink]="['/']"
      *ngIf="configurationService.currentBrand === '24hourcharts'"
      class="flex flex-shrink md:w-1/3 items-start justify-center md:justify-start text-white ml-2 focus:outline-none cursor-pointer"
      >
      <div class="w-12 h-12 object-contain rounded-lg p-1 bg-red-600 text-white mr-2">
      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><defs><clipPath clipPathUnits="userSpaceOnUse" id="a"><path d="M71.643 11.463v31.523H10.316v92.276h121.506v-9.465h13.756v18.635H290.01V73.936h-31.28V11.463zm62.472 201.746v29.922h42.242v-29.922z" stroke-width=".163"></path></clipPath></defs><path d="M168.626 225.126a3.615 3.615 0 00-3.475-3.748h-.002c-47.153-1.75-84.999-39.528-86.833-86.678h14.33a3.614 3.614 0 000-7.228h-14.33c1.808-47.067 39.55-84.807 86.616-86.613V51.57a3.614 3.614 0 007.23 0V40.86c46.422 1.795 83.89 38.555 86.569 84.936L244.635 111.7a3.614 3.614 0 00-5.11 5.11l20.174 20.175c.38.46.87.817 1.424 1.038.142.042.286.077.43.105.249.089.505.15.767.184h.205c.276-.02.548-.074.81-.16a3.4 3.4 0 00.441-.082 3.56 3.56 0 001.305-.817l20.45-20.443a3.614 3.614 0 00-5.11-5.11l-14.447 14.435c-2.582-51.806-45.3-92.507-97.17-92.584-.091-.003-.167-.05-.257-.05s-.166.047-.257.05c-53.695.074-97.205 43.584-97.279 97.28 0 .09-.05.166-.05.256s.047.166.05.257c.09 52.37 41.537 95.313 93.87 97.26h.135a3.614 3.614 0 003.61-3.477z" clip-path="url(#a)"></path><path d="M284.204 228.672h-10.843V160c-.003-3.531-4.548-4.962-6.574-2.07l-50.6 72.285c-1.676 2.395.037 5.685 2.96 5.686h46.986v10.842c0 4.819 7.228 4.819 7.228 0v-10.842h10.843c4.82 0 4.82-7.229 0-7.229zm-18.071 0h-40.047l40.047-57.207z"></path><path d="M219.147 243.13h-42.79l39.783-46.846c.09-.107.175-.22.253-.336 7.484-11.077 4.991-26.074-5.675-34.133-12.968-9.318-31.035-6.359-40.353 6.61a28.913 28.913 0 00-5.433 16.875 3.614 3.614 0 007.23 0c-.002-11.977 9.706-21.686 21.683-21.688a21.69 21.69 0 0112.652 4.072c7.471 5.725 9.211 16.268 3.976 24.09l-44.68 52.631a3.614 3.614 0 002.754 5.953h50.6a3.614 3.614 0 000-7.229zm-2.042-160.602a3.614 3.614 0 00-5.11 0l-38.84 38.835a11.32 11.32 0 00-9.22 0l-18.39-18.39a3.614 3.614 0 00-5.11 5.111l18.353 18.354c-2.577 5.394-.293 11.857 5.102 14.433a10.825 10.825 0 0012.323-2.116 10.724 10.724 0 002.089-12.313l38.803-38.804a3.614 3.614 0 000-5.11zm-46.002 51.112v.001a3.698 3.698 0 01-5.112 0 3.615 3.615 0 115.112 0zM14.079 226.55v10.063h128.065V125.926h-36.59V226.55h-9.147V75.614h-36.59V226.55h-9.148v-70.437H14.08z"></path></svg>
    </div>
    <div>
      <h1 class="pt-1 md:pt-0 text-xl font-black font-brand text-red-600 focus:outline-none"> 24-Hour Charts </h1><h4 class="text-xs text-proTeal-600 md:text-sm tracking-tight"> Simple, Dynamic, and Shareable Charts </h4>
    </div>
    </div>
    <div class="flex flex-1 md:w-1/3 justify-center md:justify-start text-white px-2">
    </div>
    <div class="flex w-full pt-4 content-center justify-between md:w-1/3 md:justify-end">
      <ul
        class="hidden md:flex list-reset text-base lg:text-lg font-bold justify-between flex-1 md:flex-none items-center"
        >
        <li
          *ngIf="authenticationService.currentUser"
          class="flex-1 md:flex-none md:mr-3 mb-1 border-2 border-l-0 border-t-0 border-r-0"
          [ngClass]="{
            'border-proTeal-400': configurationService.currentSection === 'dashboard' && configurationService.currentBrand === 'formkiq',
            'border-red-600': configurationService.currentSection === 'dashboard' && configurationService.currentBrand === '24hourcharts',
            'border-transparent': configurationService.currentSection !== 'dashboard',
            'md:hidden': configurationService.currentBrand === '24hourcharts'
          }"
          >
          <div>
            <a
              [routerLink]="['/']"
              class="py-2 px-4 cursor-pointer"
              [ngClass]="{
                'text-gray-900': configurationService.currentSection === 'dashboard',
                'text-proTeal-500 hover:text-proTeal-700': configurationService.currentSection !== 'dashboard' && configurationService.currentBrand === 'formkiq',
                'text-red-600 hover:text-red-700': configurationService.currentSection !== 'dashboard' && configurationService.currentBrand === '24hourcharts'
              }"
              >
              Dashboard
            </a>
          </div>
        </li>
        <li
          *ngIf="authenticationService.currentUser"
          class="flex-1 md:flex-none md:mr-3 mb-1 border-2 border-l-0 border-t-0 border-r-0"
          [ngClass]="{
            'border-proTeal-400': configurationService.currentSection === 'documents' && configurationService.currentBrand === 'formkiq',
            'border-red-600': configurationService.currentSection === 'documents' && configurationService.currentBrand === '24hourcharts',
            'border-transparent': configurationService.currentSection !== 'documents',
            'md:hidden': configurationService.currentBrand === '24hourcharts'
          }"
          >
          <div>
            <a
              [routerLink]="['/documents']"
              class="py-2 px-4 cursor-pointer"
              [ngClass]="{
                'text-gray-900': configurationService.currentSection === 'documents',
                'text-proTeal-500 hover:text-proTeal-700': configurationService.currentSection !== 'documents' && configurationService.currentBrand === 'formkiq',
                'text-red-600 hover:text-red-700': configurationService.currentSection !== 'documents' && configurationService.currentBrand === '24hourcharts'
              }"
              >
              Documents
            </a>
          </div>
        </li>
        <li
          *ngIf="authenticationService.currentUser"
          class="flex-1 md:flex-none md:mr-3 mb-1 border-2 border-l-0 border-t-0 border-r-0"
          [ngClass]="{
            'border-proTeal-400': configurationService.currentSection === 'integrations' && configurationService.currentBrand === 'formkiq',
            'border-red-600': configurationService.currentSection === 'integrations' && configurationService.currentBrand === '24hourcharts',
            'border-transparent': configurationService.currentSection !== 'integrations',
            'md:hidden': configurationService.currentBrand === '24hourcharts'
          }"
          >
          <a
            [routerLink]="['/integrations']"
            class="py-2 px-4 cursor-pointer"
            [ngClass]="{
              'text-gray-900': configurationService.currentSection === 'integrations',
              'text-proTeal-500 hover:text-proTeal-700': configurationService.currentSection !== 'integrations' && configurationService.currentBrand === 'formkiq',
              'text-red-600 hover:text-red-700': configurationService.currentSection !== 'integrations' && configurationService.currentBrand === '24hourcharts'
            }"
            >
            Integrations
          </a>
        </li>
        <li
          *ngIf="authenticationService.currentUser && configurationService.currentBrand === '24hourcharts'"
          class="flex-1 md:flex-none md:mr-3 mb-1 border-2 border-l-0 border-t-0 border-r-0"
          [ngClass]="{
            'border-proTeal-400': configurationService.currentSection === 'visuals' && configurationService.currentBrand === 'formkiq',
            'border-red-600': configurationService.currentSection === 'visuals' && configurationService.currentBrand === '24hourcharts',
            'border-transparent': configurationService.currentSection !== 'visuals',
            'md:hidden': configurationService.currentBrand === '24hourcharts'
          }"
          >
          <a
            [routerLink]="['/visuals']"
            class="py-2 px-4 cursor-pointer"
            [ngClass]="{
              'text-gray-900': configurationService.currentSection === 'visuals',
              'text-proTeal-500 hover:text-proTeal-700': configurationService.currentSection !== 'visuals' && configurationService.currentBrand === 'formkiq',
              'text-red-600 hover:text-red-700': configurationService.currentSection !== 'visuals' && configurationService.currentBrand === '24hourcharts'
            }"
            >
            Visuals
          </a>
        </li>
        <li
          class="flex-1 text-base md:flex-none md:ml-8 md:mr-3"
          [ngClass]="{
            'mb-3': !authenticationService.currentUser,
            'mb-2': authenticationService.currentUser
          }"
          >
          <div class="relative w-full inline-block">
            <button
              *ngIf="authenticationService.currentUser"
              (click)="toggleUserDropdown()"
              class="focus:outline-none"
              >
              <div class="flex items-center">
                <div
                  class="inline-block w-9 h-9 flex tracking-tighter items-center justify-center font-bold rounded-full text-white"
                  [ngClass]="{
                    'bg-proTeal-500': configurationService.currentBrand === 'formkiq',
                    'bg-red-600': configurationService.currentBrand === '24hourcharts',
                    'text-base': parseEmailInitials().length === 1,
                    'text-sm': parseEmailInitials().length > 1
                  }"
                  >
                  {{ parseEmailInitials() }}
                </div>
                <svg class="h-6 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </button>
            <div
              *ngIf="showUserDropdown"
              class="absolute w-32 right-0 mt-2 overflow-auto z-30 text-left text-white"
              [ngClass]="{
                'bg-proTeal-700': configurationService.currentBrand === 'formkiq',
                'bg-gray-900': configurationService.currentBrand === '24hourcharts'
              }"
              >
              <a
                [routerLink]="['/account/settings']"
                (click)="toggleUserDropdown()"
                class="px-4 py-2 hover:bg-gray-800 text-sm no-underline hover:no-underline block"
                >
                Settings
              </a>
              <a
                (click)="signOut();toggleUserDropdown()"
                class="px-4 py-2 hover:bg-gray-800 text-sm no-underline hover:no-underline block cursor-pointer"
                >
                Sign Out
              </a>
            </div>
          </div>
        </li>
      </ul>
      <ul class="flex md:hidden list-reset text-lg font-bold justify-between flex-1 md:flex-none items-center" [ngClass]="{'hidden': configurationService.currentBrand === '24hourcharts'}">
        <li
          class="relative text-base w-1/2 ml-4"
          [ngClass]="{
            'mb-1': authenticationService.currentUser,
            'mb-9': !authenticationService.currentUser
          }"
          >
          <button *ngIf="authenticationService.currentUser" class="p-1 font-bold focus:outline-none" (click)="toggleSectionDropdown()">
            <span>
              <span *ngIf="configurationService.currentSection == 'dashboard'">
                Dashboard
              </span>
              <span *ngIf="configurationService.currentSection == 'documents'">
                Documents
              </span>
              <span *ngIf="configurationService.currentSection == 'integrations'">
                Integrations
              </span>
              <span *ngIf="configurationService.currentSection == 'visuals'">
                Visuals
              </span>
            </span>
            <svg class="h-4 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </button>
          <div *ngIf="showSectionDropdown" class="absolute -mt-8 -ml-1 flex flex-row">
            <ul>
              <li class="bg-white px-2 py-1 border border-gray-400">
                <a
                  (click)="router.navigate(['dashboard']);toggleSectionDropdown()"
                  class="0text-red-600 0text-gray-900 text-proTeal-500 hover:text-proTeal-700"
                  >
                  Dashboard
                </a>
              </li>
              <li class="bg-white px-2 py-1 border border-gray-400">
                <a
                  (click)="router.navigate(['documents']);toggleSectionDropdown()"
                  class="0text-red-600 0text-gray-900 text-proTeal-500 hover:text-proTeal-700"
                  >
                  Documents
                </a>
              </li>
              <li class="bg-white px-2 py-1 border border-gray-400">
                <a
                  (click)="router.navigate(['integrations']);;toggleSectionDropdown()"
                  class="0text-red-600 0text-gray-900 text-proTeal-500 hover:text-proTeal-700"
                  >
                  Integrations
                </a>
              </li>
              <li class="bg-white px-2 py-1 border border-gray-400">
                <a
                  (click)="router.navigate(['visuals']);toggleSectionDropdown()"
                  class="0text-red-600 0text-gray-900 text-proTeal-500 hover:text-proTeal-700"
                  >
                  Visuals
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li class="text-base w-1/2 text-right">
          <div class="relative inline-block">
            <button
              *ngIf="authenticationService.currentUser"
              (click)="toggleUserDropdown()"
              class="focus:outline-none"
              >
              <div class="flex items-center">
                <div
                  class="inline-block w-9 h-9 flex tracking-tighter items-center justify-center font-bold rounded-full text-white"
                  [ngClass]="{
                    'bg-proTeal-500': configurationService.currentBrand === 'formkiq',
                    'bg-red-600': configurationService.currentBrand === '24hourcharts',
                    'text-base': parseEmailInitials().length === 1,
                    'text-sm': parseEmailInitials().length > 1
                  }"
                  >
                  {{ parseEmailInitials() }}
                </div>
                <svg class="h-4 md:h-6 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </button>
            <div
              *ngIf="showUserDropdown" 
              class="absolute right-0 mt-2 p-3 overflow-auto z-30 text-left text-white"
              [ngClass]="{
                'bg-proTeal-700': configurationService.currentBrand === 'formkiq',
                'bg-gray-900': configurationService.currentBrand === '24hourcharts'
              }"
              >
              <a
                [routerLink]="['/account/settings']"
                (click)="toggleUserDropdown()"
                class="p-2 text-sm no-underline hover:no-underline block"
                >
                Settings
              </a>
              <a
                (click)="signOut();toggleUserDropdown()"
                class="p-2 text-sm no-underline hover:no-underline block"
                >
                Sign Out
              </a>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </div>
</nav>